const sharedBase = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  maxWidth: '600px'
};

const banner = {
  alert: {
    ...sharedBase,
    backgroundColor: 'red.50'
  },
  notice: {
    ...sharedBase,
    backgroundColor: 'green.20'
  },
  warning: {
    ...sharedBase,
    backgroundColor: 'yellow.10'
  },
  white: {
    ...sharedBase,
    backgroundColor: 'white'
  }
};

export type AlertVariantsType = 'alert' | 'notice' | 'warning' | 'white';
export const alertVariants = Object.keys(banner) as AlertVariantsType[];

export default banner;
